export const localStorageKeys = {
  USER_TOKEN: 'USER_TOKEN',
}
